import Marionette from "backbone.marionette";
import PasswdTpl from "views/pwdInput/pwdInputView.ejs";
import CSS from 'views/pwdInput/pwdInput.css';
import S from "session/session.js";
import T from "session/token.js";

export default Marionette.View.extend({
    initialize: function(data) {
        this.lang = data.lang;
        this.pwd = data.pwd;
    },
    template: PasswdTpl,
    render: function() {
        this.$el.html(this.template({
            lang: this.lang,
            pwd: this.pwd
        }));
    },
    events: {
        "change #pwd": "checkPwd",
        "keyup #pwd": "checkPwd"
    },
    checkPwd: function(ev) {
        var score = this.scorePassword($(ev.target).val());
        var perc = Math.min(4, Math.round((score / 60) * 4));


        var porcenValP = perc;
        if (score <= 0) {
            porcenValP = "";
        }


        $(".strength-meter-fill").attr("data-strength", porcenValP);
        S.mApp.trigger("pwd:check", {
            score: score,
            perc: perc
        });
    },
    scorePassword: function(pass) {
        var score = 0;
        if (!pass)
            return score;

        // award every unique letter until 5 repetitions
        var letters = new Object();
        for (var i = 0; i < pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1;
            score += 5.0 / letters[pass[i]];
        }

        // bonus points for mixing it up
        var variations = {
            digits: /\d/.test(pass),
            lower: /[a-z]/.test(pass),
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass),
        }

        var variationCount = 0;
        for (var check in variations) {
            variationCount += (variations[check] == true) ? 1 : 0;
        }
        score += (variationCount - 1) * 10;

        return parseInt(score);
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/pwdInput/pwdInputView.js
// module id = 205
// module chunks = 0